<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'AboutMembersHeader',
  inject: ['wp']
}
</script>
